import FormMixin from './FormMixin';
import FormSenderMixin from './FormSenderMixin';
import FormValidatorMixin from './FormValidatorMixin';

export default {
  mixins: [FormMixin, FormSenderMixin, FormValidatorMixin],
};
